import React, { useCallback, useEffect, useRef, useState } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import config from './config'
import { Button, Modal, message } from 'antd'
import '../../index.less'
import { layoutInfoList, layoutInfoDel } from '@/services/customerServices'
import { get } from 'lodash-es'
import { modalAddOrEditFn } from './addOrEdit'

const { confirm } = Modal

export default function TableList(props: any) {
  const listRef = useRef<any>()
  const { id, onClose, visibleDrawer } = props
  const [isFirst, setIsFirst] = useState<boolean>(false)

  useEffect(() => {
    if (visibleDrawer && isFirst) {
      listRef.current.reset()
    }
  }, [visibleDrawer])

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        const dataQuery = { buildingId: id, ...query }
        layoutInfoList(current, pageSize, dataQuery).then((resp: any) => {
          setIsFirst(true)
          resolve(resp)
        })
      } catch (e) {
        setIsFirst(true)
        reject({ success: false })
      }
    })
  }
  // 删除
  const delEvent = (arr: any) => {
    layoutInfoDel({ ids: arr })
      .then(res => {
        message.success('删除成功')
        reloadFn()
      })
      .catch(() => {})
  }
  const onAdd = useCallback(() => {
    console.log(id,'add')
    modalAddOrEditFn({
      fn: () => {
        reloadFn()
      },
      buildingId: id,
    })
  }, [])
  const onDel = useCallback(e => {
    const { selectedRowKeys } = e
    confirm({
      content: `是否确认删除选中数据？`,
      onOk() {
        delEvent(selectedRowKeys)
      },
    })
  }, [])
  const onEdit = useCallback((record: any) => {
    console.log(id, 'id')
    modalAddOrEditFn({
      fn: () => {
        reloadFn()
      },
      ...record,
      buildingId: id,
    })
  }, [])
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }
  const extension = {
    request: { fetchList },
    events: { onAdd, onDel },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      unitRender(text: any) {
        return text + '㎡'
      },
      actionTool(text: any, record: any) {
        return (
          <div className="btnBox">
            <STableActions>
              <SActionBtn size={'small'} onClick={() => onEdit(record)}>
                修改
              </SActionBtn>
              <SActionBtn
                danger
                size={'small'}
                onClick={() => {
                  const arr = [`${record.id}`]
                  onDel({ selectedRowKeys: arr })
                }}
              >
                删除
              </SActionBtn>
            </STableActions>

            {/* <Button size={'small'} onClick={() => onEdit(record)}>
              修改
            </Button>
            <Button size={'small'}>删除</Button> */}
          </div>
        )
      },
    },
  }

  return <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
}
